import React, { useEffect, useState } from 'react';
import { Spin, Typography, Button } from 'antd';
import QuestionTable from './QuestionTable';
import QuestionAdd from './QuestionAdd';
import { getQuestions, updateQuestion } from '../../services/feedbackService';

const { Title, Text } = Typography;

const QuestionPage = ({ questionStatus }) => {
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [questionTableData, setQuestionTableData] = useState([]);
  const [status, setStatus] = useState({
    error: false,
    message: '',
  });
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    setStatus({ error: false, message: 'LOADING' });
    getQuestions({})
      .then((response) => {
        const data = response?.data?.questions.filter((question) => {
          if (questionStatus === 'active') {
            return !question.isArchived;
          } else {
            return question.isArchived;
          }
        });
        setQuestionTableData(data);
        setTotalCount(data.length);
        setStatus({ error: false, message: 'SUCCESS' });
      })
      .catch((err) => {
        setStatus({
          error: true,
          message: `${err}`,
        });
      });
  }, []);

  const archiveAndRemoveItem = (item, index) => {
    updateQuestion(item._id, { isArchived: questionStatus === 'active' })
      .then((res) => {
        let newData = questionTableData;
        newData.splice(index, 1);
        newData = [...newData];
        setQuestionTableData(newData);
        setTotalCount(newData.length);
      })
      .catch((err) => {
        alert(err);
      });
  };

  return (
    <>
      <div
        style={{
          paddingBottom: '40px',
        }}
      >
        <Text
          style={{
            float: 'left',
            position: 'relative',
          }}
        >
          Total Questions:{' '}
          <strong style={{ fontSize: '20px' }}>{totalCount}</strong> records
        </Text>

        {questionStatus === 'active' && (
          <Button
            style={{
              float: 'right',
              position: 'relative',
            }}
            onClick={() => {
              setIsAddModalVisible(true);
            }}
          >
            Add Question
          </Button>
        )}
      </div>

      {questionStatus === 'active' && (
        <QuestionAdd
          isOpen={isAddModalVisible}
          toggle={() => setIsAddModalVisible(false)}
        />
      )}

      {status.error ? (
        <div style={{ marginTop: '50px', textAlign: 'center' }}>
          <Title>{status.message}</Title>
        </div>
      ) : status.message === 'LOADING' ? (
        <Spin />
      ) : (
        <QuestionTable
          data={questionTableData}
          archiveItem={archiveAndRemoveItem}
          status={questionStatus}
        />
      )}
    </>
  );
};

export default QuestionPage;
